import { createSlice } from '@reduxjs/toolkit'
import { fetchAllCustomers } from '../actions/customerAction'

const CustomerReducers = createSlice({
    name: 'CustomerReducers',
    initialState: {
        loader: false,
        errors: null,
        customers: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * ALL Customers
             */
            .addCase(fetchAllCustomers.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(fetchAllCustomers.fulfilled, (state, action) => {
                state.loader = false;
                state.customers = action.payload.data;
            })
            .addCase(fetchAllCustomers.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            });
    }
})

export default CustomerReducers.reducer